import CssBaseline from '@mui/material/CssBaseline';
import {createTheme, ThemeProvider as MuiThemeProvider} from '@mui/material/styles';
import {FC, useMemo} from 'react';
import {ThemeProvider} from 'styled-components';

import {CssReset} from '@shared_web/components/core/css_reset';
import {ErrorBoundary} from '@shared_web/components/core/error_boundary';
import {GlobalStyle} from '@shared_web/components/core/global_styles';

import {App} from '@website_frontend/components/app';
import {SwipperCss} from '@website_frontend/components/swipper_css';
import {useAppTheme} from '@website_frontend/theme';

export const Root: FC = () => {
  const theme = useAppTheme();

  const muiTheme = useMemo(() => createTheme(), []);
  return (
    <ThemeProvider theme={theme}>
      <CssReset />
      <SwipperCss />
      <MuiThemeProvider theme={muiTheme}>
        <CssBaseline />
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </MuiThemeProvider>
      <GlobalStyle />
    </ThemeProvider>
  );
};
Root.displayName = 'Root';
